import { de, en, fr, nl, ko } from 'vuetify/src/locale';

var vuetifyLanguages = {
  de,
  en,
  fr,
  nl,
  ko
};

export { vuetifyLanguages as default };
